import { mergeStyleSets } from '@uifabric/styling';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export const buttonStyles = {
  rootHovered: {
    backgroundColor: 'transparent',
  },
  rootPressed: {
    backgroundColor: 'transparent',
  },
};

export const textBoxStyles = {
  prefix: {
    backgroundColor: 'transparent',
  },
  suffix: {
    backgroundColor: 'transparent',
  },
};

export default mergeStyleSets({
  root: {
    position: 'relative',
    width: '100%',
  },
  textBox: {
    position: 'relative',
    top: 0,
  },
  dropdownContainer: {
    maxHeight: pxToRem(400),
  },
  errorMessage: {
    borderColor: theme.palette.accentError,
    color: theme.palette.accentError,
    fontWeight: 400,
    fontSize: pxToRem(12),
    paddingTop: pxToRem(5),
  },
  rightPadding: {
    paddingRight: pxToRem(5),
  },
});
